import { deleteAssignment as deleteAssignmentAPI } from "../api";

export const deleteAssignmentAction = async (userID, assignmentID, setUser) => {
  const user = await deleteAssignmentAPI(userID, assignmentID);
  setUser(user.data)
};
